module.exports = __webpack_public_path__ + "img/ic_tour.d45e8be2.svg";